import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/purchases`, {
    params: {
      ...params
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/purchases`, body, config);
};

export const Put = (id, body, config = {}) => {
  return APIService.put(`/v01/purchases/${id}`, body, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/purchases/${id}`, config);
};

export const PurchaseStatus = () => {
  return APIService.get(`/v01/purchase-status`);
}

export const PaymentMethod = () => {
  return APIService.get(`/v01/payment-method`);
}

export const Detail = (id) => {
  return APIService.get(`/v01/purchases/${id}`);
};

export const PaymentStatus = () => {
  return APIService.get(`/v01/payment-status`);
}

export const CreditPurchaseList = (params) => {
  return APIService.get(`/v01/credit-purchases`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
}

export const UpdateStatus = (id, body, config = {}) => {
  return APIService.put(`/v01/purchases/${id}/status`, body, config);
};

export const ReverseReceipt = (id, body, config = {}) => {
  return APIService.post(`/v01/purchases/${id}/reverse-receipt`, body, config);
};

export const Products = (params = {}) => {
  return APIService.get(`/v01/purchase-products`, { params });
};

export const SearchProducts = (params = {}, config = {}) => {
  return APIService.get(`/v01/purchase-products/search`, { params, ...config });
};

const PurchaseService = {
  List,
  Create,
  Put,
  Delt,
  Detail,
  PurchaseStatus,
  PaymentMethod,
  PaymentStatus,
  CreditPurchaseList,
  UpdateStatus,
  ReverseReceipt,
  Products,
  SearchProducts,
};
export default PurchaseService;
